<template>
  <button
    class="add-answer-button"
    @click="handleClick"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
    @mousedown="handleMouseDown"
    @mouseup="handleMouseUp"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10 6V14M6 10H14M5.8 19H14.2C15.8802 19 16.7202 19 17.362 18.673C17.9265 18.3854 18.3854 17.9265 18.673 17.362C19 16.7202 19 15.8802 19 14.2V5.8C19 4.11984 19 3.27976 18.673 2.63803C18.3854 2.07354 17.9265 1.6146 17.362 1.32698C16.7202 1 15.8802 1 14.2 1H5.8C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8V14.2C1 15.8802 1 16.7202 1.32698 17.362C1.6146 17.9265 2.07354 18.3854 2.63803 18.673C3.27976 19 4.11984 19 5.8 19Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <span class="add-answer-button__label">{{ label }}</span>
  </button>
</template>

<script setup>
import { ref } from "vue";

/**
 * AddAnswerButton Component
 * A button component with a square outline containing a plus icon and text label
 */

const props = defineProps({
  label: {
    type: String,
    default: "Add Answer",
  },
});

const emit = defineEmits(["click"]);

// Internal state for hover and active interactions
const isHovered = ref(false);
const isActive = ref(false);

const handleClick = (event) => {
  emit("click", event);
};

const handleMouseEnter = () => {
  isHovered.value = true;
};

const handleMouseLeave = () => {
  isHovered.value = false;
  isActive.value = false;
};

const handleMouseDown = () => {
  isActive.value = true;
};

const handleMouseUp = () => {
  isActive.value = false;
};
</script>

<style scoped>
@import "./addAnswerButton.css";
</style>
